var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancelButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.34 0.5C17.73 0.5 20 2.88 20 6.42V14.591C20 18.121 17.73 20.5 14.34 20.5H5.67C2.28 20.5 0 18.121 0 14.591V6.42C0 2.88 2.28 0.5 5.67 0.5H14.34ZM13.01 7.471C12.67 7.13 12.12 7.13 11.77 7.471L10 9.25L8.22 7.471C7.87 7.13 7.32 7.13 6.98 7.471C6.64 7.811 6.64 8.371 6.98 8.71L8.76 10.491L6.98 12.261C6.64 12.611 6.64 13.161 6.98 13.5C7.15 13.67 7.38 13.761 7.6 13.761C7.83 13.761 8.05 13.67 8.22 13.5L10 11.731L11.78 13.5C11.95 13.681 12.17 13.761 12.39 13.761C12.62 13.761 12.84 13.67 13.01 13.5C13.35 13.161 13.35 12.611 13.01 12.271L11.23 10.491L13.01 8.71C13.35 8.371 13.35 7.811 13.01 7.471Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelButton);
export default __webpack_public_path__ + "static/media/cancel_button.6a9115ea919d85ce802918cc6d2f5e34.svg";
export { ForwardRef as ReactComponent };